import { render, staticRenderFns } from "./PutForeground.vue?vue&type=template&id=4db99430&"
import script from "./PutForeground.vue?vue&type=script&lang=js&"
export * from "./PutForeground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports